export interface SEOMetadata {
  url: string;
  canonical: string;
  title: string;
  description: string;
  heading?: string | null;
}

export const seoConfig: SEOMetadata[] = [
  {
    url: "/",
    canonical: "https://falektayyeb.ae/",
    title: "Best Emirati Hiring Platform in Dubai, UAE - Forsatak",
    description: "Forsatak is a leading Emirati hiring platform based in Dubai, UAE, connecting leading employers with skilled Emirati talent through expert recruiters.",
    heading: "Leading Emirati Hiring Agency in Dubai",
  },
  {
    url: "/faq",
    canonical: "https://falektayyeb.ae/faq",
    title: "FAQs | Everything You Need to Know About Forsatak",
    description: "Find answers to frequently asked questions about Forsatak. Discover everything you need to know in one place, from talent hiring to support information.",
    heading: "FAQs",
  },
  {
    url: "/privacy-policy",
    canonical: "https://falektayyeb.ae/privacy-policy",
    title: "Privacy Policy | Forsatak – Data Protection & User Rights",
    description: "Learn how Forsatak UAE collects, uses, and protects your personal information. Read our privacy policy for full transparency on data usage and user rights.",
    heading: null,
  },
  {
    url: "/terms-of-use",
    canonical: "https://falektayyeb.ae/terms-of-use",
    title: "Terms of Use | Forsatak – Legal Terms & Conditions",
    description: "Read the Terms of Use for Forsatak to understand the legal guidelines, user responsibilities, and conditions for using our website and services in the UAE.",
    heading: null,
  },
];

export const getSEOByPath = (path: string): SEOMetadata | undefined => {
  return seoConfig.find(seo => seo.url === path);
};